<template>
  <div class="contact-us">
    <MainNav />
    <div class="jumbotron jumbotron-fluid bg-light">
      <div class="container">
        <h1>Contact Us</h1>
      </div>
    </div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="vh-50">
            <iframe
              class="h-100 w-100"
              marginheight="0"
              marginwidth="0"
              scrolling="no"
              src="https://maps.google.com/maps?hl=en&amp;q=Cornwall Wildlife Trust Five Acres Allet Truro Cornwall TR4 9DJ&amp;ie=UTF8&amp;t=roadmap&amp;z=11&amp;iwloc=B&amp;output=embed"
              frameborder="0"
            ></iframe>
          </div>
        </div>
        <div class="col-md-6">
          <h2 class="h4">Registered Office</h2>

          <address>
            <strong
              >Environmental Records Centre for Cornwall and Isles of Scilly
              (ERCCIS)</strong
            ><br />
            Five Acres<br />
            Allet<br />
            Truro<br />
            Conrwall<br />
            TR4 9DJ<br />
            <abbr title="Phone">T: </abbr
            ><a href="tel:01872 302250">01872 302250</a><br />
            <abbr title="Email">E: </abbr
            ><a href="mailto:datasearch@erccis.org.uk"
              >datasearch@erccis.org.uk</a
            >
          </address>

          <p>Our office hours are Monday to Friday 8.30am - 4.30pm</p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <h3 class="h5">Other useful contacts</h3>

          <strong>Cornwall Wildlife Trust</strong>

          <p>
            <a href="tel:01872 273 939">01872 273 939</a> |
            <a href="mailto:info@cornwallwildlifetrust.org.uk"
              >info@cornwallwildlifetrust.org.uk</a
            >
          </p>

          <strong>Wildlife Information Service (WIS)</strong>

          <p>
            <a href="tel:01872 302254">01872 302254</a> |
            <a href="mailto:wis@cornwallwildlifetrust.org.uk"
              >wis@cornwallwildlifetrust.org.uk</a
            >
          </p>

          <!-- <strong>Cornwall Environmental Consultants</strong>

					<p><a href="tel:01872 245510">01872 245510</a>  |  <a href="mailto:enquiries@cecenvironment.co.uk">enquiries@cecenvironment.co.uk</a></p>

					<strong>Cornwall Marine Strandings Network</strong>

					<p>24-hour emergency hotline: <a href="tel:0345 201 2626">0345 201 2626</a></p> -->
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "ContactUs",
  components: {
    MainNav,
    Footer
  },
  data() {
    return {
      center: {
        lat: 50.295414,
        lng: -5.098628
      },
      zoom: 10,
      mapOptions: {
        fullscreenControl: false,
        streetViewControl: false,
        disableDoubleClickZoom: true,
        draggableCursor: "pointer"
      }
    };
  }
};
</script>
